<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/users']">Usuarios</a></li>
</ul>
<app-view #view [code]="'users.list'" [model]="usersFilters" (onEvent)="onEvent($event)"></app-view>
